import { ContentCopy, Facebook, Instagram, WhatsApp } from "@mui/icons-material";
import React from "react";
import { handleCopy } from "../utils/Universalfunctions";

const ShareSection = ({ url }) => {
     const shareUrl = encodeURIComponent(url);
     const shareText = encodeURIComponent("Check this out!");

     const openShare = (url) => {
          window.open(url, "_blank");
     };



     const shareToInstagram = async () => {
          try {
               await navigator.clipboard.writeText(url);
               alert("Link copied! Paste it in Instagram chat 📋");
               window.open("https://www.instagram.com/direct/inbox/", "_blank");
          } catch (err) {
               window.open("https://www.instagram.com/", "_blank");
          }
     };


     return (
          <div className="share-section">
               <button
                    className="share-btn facebook"
                    onClick={() =>
                         openShare(
                              `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`
                         )
                    }
               >
                    <Facebook />
               </button>

               <button
                    className="share-btn whatsapp"
                    onClick={() =>
                         openShare(
                              `https://wa.me/?text=${shareText}%20${shareUrl}`
                         )
                    }
               >
                    <WhatsApp />
               </button>

               <button
                    className="share-btn instagram"
                    onClick={shareToInstagram}
               >
                    <Instagram />
               </button>

                <button className="share-btn copybtn" onClick={() => handleCopy(url)}>
                    <ContentCopy />
               </button>
          </div>
     );
};

export default ShareSection;
